import { useEffect, useState } from "react";
import { ArrowUpRight, X } from "lucide-react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "revgrow.announce.dismiss.v1";

export default function AnnouncementBar() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) === "1") setVisible(false);
    } catch {
      /* ignore */
    }
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
    setVisible(false);
    try { window.dispatchEvent(new CustomEvent("announcement:dismissed")); } catch { /* ignore */ }
  };

  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 inset-x-0 z-[60] bg-[#040810] border-b border-white/5"
    >
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-2 flex items-center gap-3">
        <div className="hidden sm:flex items-center gap-2 shrink-0">
          <span className="h-1.5 w-1.5 rounded-full bg-teal pulse-dot" />
          <span className="text-[10px] font-mono uppercase tracking-[0.22em] text-teal">
            New
          </span>
        </div>
        <Link
          to="/insights/revgrow-launches-hyderabad-delivery-centre"
          data-testid="announcement-cta"
          className="flex-1 min-w-0 text-[12px] md:text-[13px] text-foreground/85 hover:text-teal inline-flex items-center gap-1.5 truncate"
        >
          <span className="truncate">
            RevGrow launches AI-Native Demand Generation delivery vertical — read the announcement
          </span>
          <ArrowUpRight size={13} className="shrink-0" />
        </Link>
        <button
          data-testid="announcement-dismiss"
          onClick={dismiss}
          aria-label="Dismiss announcement"
          className="shrink-0 text-muted-foreground hover:text-foreground"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
